import { AlienAnimation } from '@/playlist/games/timeGame/types';

import alienArieCorrect from '@/playlist/games/timeGame/assets/lottie/aliens/alien-arie-correct.json';
import alienArieIdle from '@/playlist/games/timeGame/assets/lottie/aliens/alien-arie-idle.json';
import alienArieIrritated from '@/playlist/games/timeGame/assets/lottie/aliens/alien-arie-irritated.json';
import alienArieWrong from '@/playlist/games/timeGame/assets/lottie/aliens/alien-arie-wrong.json';
import alienDirkDuikerCorrect from '@/playlist/games/timeGame/assets/lottie/aliens/alien-dirk-duiker-correct.json';
import alienDirkDuikerIdle from '@/playlist/games/timeGame/assets/lottie/aliens/alien-dirk-duiker-idle.json';
import alienDirkDuikerIrritated from '@/playlist/games/timeGame/assets/lottie/aliens/alien-dirk-duiker-irritated.json';
import alienDirkDuikerWrong from '@/playlist/games/timeGame/assets/lottie/aliens/alien-dirk-duiker-wrong.json';
import alienFrisseFritsCorrect from '@/playlist/games/timeGame/assets/lottie/aliens/alien-frisse-frits-correct.json';
import alienFrisseFritsIdle from '@/playlist/games/timeGame/assets/lottie/aliens/alien-frisse-frits-idle.json';
import alienFrisseFritsIrritated from '@/playlist/games/timeGame/assets/lottie/aliens/alien-frisse-frits-irritated.json';
import alienFrisseFritsWrong from '@/playlist/games/timeGame/assets/lottie/aliens/alien-frisse-frits-wrong.json';
import alienGeleGilbertCorrect from '@/playlist/games/timeGame/assets/lottie/aliens/alien-gele-gilbert-correct.json';
import alienGeleGilbertIdle from '@/playlist/games/timeGame/assets/lottie/aliens/alien-gele-gilbert-idle.json';
import alienGeleGilbertIrritated from '@/playlist/games/timeGame/assets/lottie/aliens/alien-gele-gilbert-irritated.json';
import alienGeleGilbertWrong from '@/playlist/games/timeGame/assets/lottie/aliens/alien-gele-gilbert-wrong.json';
import alienHarigeHarryCorrect from '@/playlist/games/timeGame/assets/lottie/aliens/alien-harige-harry-correct.json';
import alienHarigeHarryIdle from '@/playlist/games/timeGame/assets/lottie/aliens/alien-harige-harry-idle.json';
import alienHarigeHarryIrritated from '@/playlist/games/timeGame/assets/lottie/aliens/alien-harige-harry-irritated.json';
import alienHarigeHarryWrong from '@/playlist/games/timeGame/assets/lottie/aliens/alien-harrige-harry-wrong.json';
import alienOranjeOlafCorrect from '@/playlist/games/timeGame/assets/lottie/aliens/alien-oranje-olaf-correct.json';
import alienOranjeOlafIdle from '@/playlist/games/timeGame/assets/lottie/aliens/alien-oranje-olaf-idle.json';
import alienOranjeOlafIrritated from '@/playlist/games/timeGame/assets/lottie/aliens/alien-oranje-olaf-irritated.json';
import alienOranjeOlafWrong from '@/playlist/games/timeGame/assets/lottie/aliens/alien-oranje-olaf-wrong.json';
import alienPeterPatvinderCorrect from '@/playlist/games/timeGame/assets/lottie/aliens/alien-peter-patvinder-correct.json';
import alienPeterPatvinderIdle from '@/playlist/games/timeGame/assets/lottie/aliens/alien-peter-patvinder-idle.json';
import alienPeterPatvinderIrritated from '@/playlist/games/timeGame/assets/lottie/aliens/alien-peter-patvinder-irritated.json';
import alienPeterPatvinderWrong from '@/playlist/games/timeGame/assets/lottie/aliens/alien-peter-patvinder-wrong.json';
import alienTeddyToddlerCorrect from '@/playlist/games/timeGame/assets/lottie/aliens/alien-teddy-toddler-correct.json';
import alienTeddyToddlerIdle from '@/playlist/games/timeGame/assets/lottie/aliens/alien-teddy-toddler-idle.json';
import alienTeddyToddlerIrritated from '@/playlist/games/timeGame/assets/lottie/aliens/alien-teddy-toddler-irritated.json';
import alienTeddyToddlerWrong from '@/playlist/games/timeGame/assets/lottie/aliens/alien-teddy-toddler-wrong.json';
import alienWinterWinstonCorrect from '@/playlist/games/timeGame/assets/lottie/aliens/alien-winter-winston-correct.json';
import alienWinterWinstonIdle from '@/playlist/games/timeGame/assets/lottie/aliens/alien-winter-winston-idle.json';
import alienWinterWinstonIrritated from '@/playlist/games/timeGame/assets/lottie/aliens/alien-winter-winston-irritated.json';
import alienWinterWinstonWrong from '@/playlist/games/timeGame/assets/lottie/aliens/alien-winter-winston-wrong.json';

export const alienAnimations: AlienAnimation[] = [
	{
		id: 'alien-arie',
		idleAnimation: alienArieIdle,
		irritatedAnimation: alienArieIrritated,
		correctAnimation: alienArieCorrect,
		wrongAnimation: alienArieWrong,
	},
	{
		id: 'alien-dirk-duiker',
		idleAnimation: alienDirkDuikerIdle,
		irritatedAnimation: alienDirkDuikerIrritated,
		correctAnimation: alienDirkDuikerCorrect,
		wrongAnimation: alienDirkDuikerWrong,
	},
	{
		id: 'alien-frisse-frits',
		idleAnimation: alienFrisseFritsIdle,
		irritatedAnimation: alienFrisseFritsIrritated,
		correctAnimation: alienFrisseFritsCorrect,
		wrongAnimation: alienFrisseFritsWrong,
	},
	{
		id: 'alien-gele-gilbert',
		idleAnimation: alienGeleGilbertIdle,
		irritatedAnimation: alienGeleGilbertIrritated,
		correctAnimation: alienGeleGilbertCorrect,
		wrongAnimation: alienGeleGilbertWrong,
	},
	{
		id: 'alien-harige-harry',
		idleAnimation: alienHarigeHarryIdle,
		irritatedAnimation: alienHarigeHarryIrritated,
		correctAnimation: alienHarigeHarryCorrect,
		wrongAnimation: alienHarigeHarryWrong,
	},
	{
		id: 'alien-oranje-olaf',
		idleAnimation: alienOranjeOlafIdle,
		irritatedAnimation: alienOranjeOlafIrritated,
		correctAnimation: alienOranjeOlafCorrect,
		wrongAnimation: alienOranjeOlafWrong,
	},
	{
		id: 'alien-peter-patvinder',
		idleAnimation: alienPeterPatvinderIdle,
		irritatedAnimation: alienPeterPatvinderIrritated,
		correctAnimation: alienPeterPatvinderCorrect,
		wrongAnimation: alienPeterPatvinderWrong,
	},
	{
		id: 'alien-teddy-toddler',
		idleAnimation: alienTeddyToddlerIdle,
		irritatedAnimation: alienTeddyToddlerIrritated,
		correctAnimation: alienTeddyToddlerCorrect,
		wrongAnimation: alienTeddyToddlerWrong,
	},
	{
		id: 'alien-winter-winston',
		idleAnimation: alienWinterWinstonIdle,
		irritatedAnimation: alienWinterWinstonIrritated,
		correctAnimation: alienWinterWinstonCorrect,
		wrongAnimation: alienWinterWinstonWrong,
	},
];
